import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TShipmentsStore, THsCodeDescriptionResponsePayload } from './types';

// ==========================================:
const getShipmentsState = (state: TStoreState): TShipmentsStore => state.shipments;
export const getShipments = getShipmentsState;

// ====================================================:
export const getIsSwissPostIntegrationEnabledIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore): boolean => shipments.isSwissPostIntegrationEnabledLoading,
);

// ====================================================:
export const getIsSwissPostIntegrationEnabled = createSelector(
	[getShipments],
	(shipments: TShipmentsStore): boolean => shipments.isSwissPostIntegrationEnabled,
);
// ====================================================:

export const getShipmentsOrders = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentOrders,
);

// ====================================================:

export const getShipmentsOrdersIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentOrdersLoading,
);

// ====================================================:

export const getShipmentsOrder = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentOrder,
);

// ====================================================:

export const getShipmentsOrderIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentOrderLoading,
);

// ====================================================:

export const getShipmentsLabel = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentLabel,
);

// ====================================================:

export const getShipmentsLabelIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentLabelLoading,
);

// ====================================================:

export const getRequestDeliveryIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.requestDeliveryLoading,
);

// ====================================================:

export const getRequestDeliveryError = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.requestDeliveryError,
);

// ====================================================:

export const getSendLastErrorByEmailIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.sendLastErrorByEmailLoading,
);

// ====================================================:

export const getSendLastErrorByEmailError = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.sendLastErrorByEmailError,
);

// ====================================================:

export const getSendLastErrorByEmailSuccess = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.sendLastErrorByEmailSuccess,
);

// ====================================================:

export const getShipmentProformaIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentProformaLoading,
);

// ====================================================:

export const getShipmentsOrderError = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentOrderError,
);

// ====================================================:

export const getUpdateHsCodeLoading = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.updateHsCodeLoading,
);

// ====================================================:

export const getHsCodeDescription = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.hsCodeDescription,
);

// ====================================================:

export const getHsCodeDescriptionIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.hsCodeDescriptionLoading,
);

// ====================================================:

export const uploadShipmentProformaIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentProformaUploadLoading,
);

// ====================================================:

export const getShipmentProformaUploadError = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.shipmentProformaUploadError,
);

// ====================================================:

export const getUnsignedProforma = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.unsignedProforma,
);

// ====================================================:

export const getUnsignedProformaIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.unsignedProformaLoading,
);

// ====================================================:

export const getSignedProformaPreview = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.signedProformaPreview,
);

// ====================================================:

export const getSignedProformaPreviewIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.signedProformaPreviewLoading,
);

// ====================================================:

export const getUpdateWeightIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore): boolean => shipments.updateWeightLoading,
);

// ====================================================:

export const getUpdateWeightError = createSelector(
	[getShipments],
	(shipments: TShipmentsStore): { productId: string; ts: number } | null =>
		shipments.updateWeightError,
);

// ====================================================:

export const getFirstMileLabelIsLoad = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.firstMileLabelLoading,
);

// ====================================================:

export const getFirstMileLabelErrorDialog = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.firstMileLabelErrorDialog,
);

// ====================================================:

export const getFirstMileLabelError = createSelector(
	[getShipments],
	(shipments: TShipmentsStore) => shipments.firstMileLabelError,
);
